import { requestGet, requestPost } from '@/common/request';

// 黑白名单可见性 https://joyspace.jd.com/pages/y7NkCwBrtNJDK6y3sje4
export async function whiteListPermission(query) {
  return requestGet('/whiteTemplateInfo/whiteListPermission', query);
}

// 类型枚举https://joyspace.jd.com/pages/qEdM7Pz6r2Ik9HkElxB6
export async function listWhiteEnum(query) {
  return requestGet('/whiteTemplateInfo/listWhiteConfig', query);
}

//新增模板https://joyspace.jd.com/pages/4vJ6MRl2igyuIIWq2BSs
export async function addWhiteTemplate(query) {
  return requestPost('/whiteTemplateInfo/addWhiteTemplate', query);
}

// 编辑模板https://joyspace.jd.com/pages/gYspxh5qc8u3ar5Kj0T7
export async function updateWhiteTemplate(query) {
  return requestPost('/whiteTemplateInfo/updateWhiteTemplate', query);
}

// 查看模板详情 https://joyspace.jd.com/pages/gjKhd28tvIS4Zluz1BiL
export async function templateDetail(query) {
  return requestGet('/whiteTemplateInfo/selectById', query);
}

// 模板列表查询 https://joyspace.jd.com/pages/QZBKkAs2Px9ufJwHj5WV
export async function queryList(query) {
  return requestGet('/whiteTemplateInfo/list', query);
}
// 添加管理员 https://joyspace.jd.com/pages/agvZLFmJI1E6JNzZ8KEN
export async function addManager(query) {
  return requestGet('/whiteTemplateInfo/addManager', query);
}
// 查询管理员 https://joyspace.jd.com/pages/bpKSI19JbC4o7gGb94qM
export async function managerList(query) {
  return requestGet('/whiteTemplateInfo/managerList', query);
}
// 删除管理员https://joyspace.jd.com/pages/PqgzbP0IrH3JFeWFiuzK
export async function deleteManager(query) {
  return requestGet('/whiteTemplateInfo/deleteManager', query);
}

// 分配权限列表https://joyspace.jd.com/pages/XO8VGvpgtSUfoaZPR4dr
export async function getMemberList(query) {
  return requestPost('/white/member/list', query);
}

// 删除分配https://joyspace.jd.com/pages/YNTcjcH1C8R1PQ3EGGu0
export async function deleteMemberList(query) {
  return requestPost('/white/member/delete', query);
}

// 添加分配https://joyspace.jd.com/pages/LaVkrWx0Jyi2Nrz3lfTc
export async function addMemberList(query) {
  return requestPost('/white/member/add', query);
}

// 模板绑定活动操作
export async function bindActivity(query) {
  return requestPost('/whiteTemplateInfo/bindActivity', query);
}

// 基础信息 https://joyspace.jd.com/pages/W7o5gI1eldBcds16MnuA
export async function queryApplyWhiteForm(query) {
  return requestGet('/whiteTemplateApply/queryApplyForm', query);
}

// 上传文件 https://joyspace.jd.com/pages/xvV7oY0fgFY4LF3aQrgp
export async function uploadWhiteFile(query) {
  return await requestPost('/whiteTemplateApply/fileUpload', query);
}

// C172、黑白名单活动申请-申请人可申请的白名单列表 https://joyspace.jd.com/pages/2KGZnVdr9YNe0UtzGydA
export async function listApplyWhite(query) {
  return requestGet('/whiteTemplateInfo/listApplyWhite', query);
}

// C176、黑白名单活动申请-查询白名单文件处理结果 https://joyspace.jd.com/pages/5ZjZ08yYzRGSWJMfVdNI
export async function queryFileTaskResult(query) {
  return requestGet('/whiteTemplateApply/queryFileTaskResult', query);
}

// C174、黑白名单活动申请-申请人提交申请 https://joyspace.jd.com/pages/mQtM8cDiES999Q0cDHPU
export async function commitWhiteApply(query) {
  return requestPost('/whiteTemplateApply/submit', query);
}
// C173、黑白名单活动申请-申请人已申请的列表 https://joyspace.jd.com/pages/UGxXAW9P2iO7jUXHRV5q
export async function alreadyApplyWhite(query) {
  return requestGet('/whiteTemplateInfo/alreadyApplyWhite', query);
}

// erp有效性校验 https://joyspace.jd.com/pages/wcWPhytvlLPVbbgEWWGJ
export async function validErp(query) {
  return requestGet('/pin/valid', query);
}
